<template>
  <SearchableInput
    v-if="contracts.length > 5"
    @changes="onChange"
    :options="searchableOptions"
    placeholder="Sök efter adress eller företagsnamn"
  />

  <div v-else-if="contracts.length !== 0" class="flex flex-col gap-4">
    <template v-for="contract in contracts" :key="contract.rentalObjectCode">
      <div v-if="contract.status !== 'coming'">
        <input
          type="radio"
          name="rentalObjectCode"
          class="peer hidden"
          :key="contract.rentalObjectCode"
          :value="contract.rentalObjectCode"
          :id="contract.rentalObjectCode"
          :checked="internalValue === contract.rentalObjectCode"
          @change="onChange(contract.rentalObjectCode)"
        />
        <Label :val="contract.rentalObjectCode" :id="contract.rentalObjectCode" :name="contract.rentalObject.address1" :internalValue="internalValue" :onChange="onChange" />
      </div>
    </template>
  </div>
  <div v-else>Det verkar inte som du har några kontrakt av den aktuella typen.</div>
</template>

<script>
import SearchableInput from '@/components/ui/searchableinput';
import Label from '@/components/ui/label';

export default {
  name: 'ChooseContract',
  components: { SearchableInput, Label },
  props: {
    areaCode: {
      type: String,
      required: true,
    },
    rentalObjectCode: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    dir: {
      required: false
    }
  },
  data() {
    return {
      showLoader: false,
      internalValue: null,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      },
    },
  },
  computed: {
    /**
     * Kontrakt, filtrerar på typ av area man valt.
     */
    contracts() {
      const selectedArea = this.$store.getters.getErrorReportAreaByCode;
      console.log("selectedArea", selectedArea, this.areaCode)
      if (!selectedArea) return [];

      return this.$store.getters.getContractsByRentalObjectTypes(this.areaCode);
    },

    /**
     * Används av söken, om den visas
     */
    searchableOptions() {
      let options = {};
      this.contracts.forEach((opt) => {
        const texts = [opt.rentalObject.address1, opt.contractNumber];

        options[opt.rentalObjectCode] = texts.join(', ');
      });

      return options;
    },
  },
  methods: {
    onChange(value) {
      this.$emit('update:rentalObjectCode', value)
      this.$emit('change', value);
    },
  },
  created() {
    this.internalValue = this.rentalObjectCode;
    if (this.rentalObjectCode && this.dir =="prev") this.$emit('update:rentalObjectCode', this.internalValue);
  },
};
</script>
